declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

export const trackClarityEvent = (
  eventName: string,
  data?: Record<string, any>
) => {
  try {
    if (window.clarity) {
      window.clarity("event", eventName, data || {});
    }
  } catch (error) {
    console.error("Clarity error:", error);
  }
};